import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-patients-loading',
  templateUrl: './patients-loading.component.html',
  styleUrls: ['./patients-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class PatientsLoadingComponent {}
